var _StyledDivider;
import React from 'react';
import { node } from 'prop-types';
import { styled } from '@mui/material/styles';
import SovosTypography from "../../sovos-typography";
import SovosDivider from "../../sovos-divider";
import SovosFixedWidthText from "../../sovos-fixed-width-text";
var Root = styled('div')(function (_ref) {
  var spacing = _ref.theme.spacing;
  return {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    minHeight: spacing(5),
    margin: 0,
    padding: "0 ".concat(spacing(2))
  };
});
var StyledDivider = styled(SovosDivider)(function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    position: 'absolute',
    top: '50%',
    left: spacing(2),
    right: spacing(2)
  };
});
var StyledTypography = styled(SovosTypography)(function (_ref3) {
  var _ref3$theme = _ref3.theme,
    palette = _ref3$theme.palette,
    spacing = _ref3$theme.spacing;
  return {
    background: palette.common.white,
    display: 'inline-block',
    paddingRight: spacing(),
    maxWidth: '100%',
    position: 'relative'
  };
});
var SectionDivider = function SectionDivider(_ref4) {
  var content = _ref4.content;
  return /*#__PURE__*/React.createElement(Root, null, _StyledDivider || (_StyledDivider = /*#__PURE__*/React.createElement(StyledDivider, null)), content && /*#__PURE__*/React.createElement(StyledTypography, {
    className: "sovosTreeListItem__header",
    color: "text.secondary",
    component: "h6",
    variant: "body1"
  }, typeof content === 'string' ? /*#__PURE__*/React.createElement(SovosFixedWidthText, {
    text: content,
    className: "sovosTreeListText"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, content)));
};
SectionDivider.propTypes = {
  content: node
};
export default SectionDivider;